import { NFTI, WalletProviderE } from '@tacans/shared-marketplace-layer';
import { useCallback } from 'react';
import { useBlockChains } from 'src/features/common/wallet/hooks/wallet.hooks';

export const useGetNftWalletProvider = () => {
    const blockChains = useBlockChains();

    return useCallback(
        (nft: NFTI): WalletProviderE => {
            const chain = blockChains.find((b) => nft.blockchainId === b.id);

            if (chain) {
                return chain.name as WalletProviderE;
            }
            return WalletProviderE.Concordium;
        },
        [blockChains]
    );
};
